var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSarcoidosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    id: "svg38",
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .sarcoidosis {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sarcoidosis__x26__Cardiopulmonar",
    transform: "translate(-55,-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2",
    clipPath: "url(#clippath-sarcoidosis-6)",
    id: "g25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "sarcoidosis",
    d: "m 65.84,28.23 c -1.1,-1.13 -2.46,-0.41 -3.76,1.17 -1.7,2.06 -2.06,3.86 -2.41,5.76 -0.41,2.22 -0.81,6.15 1.13,6.84 1,0.36 7.79,2.7 5.6,-8.71 -0.21,-1.09 0.5,-3.96 -0.56,-5.05 z",
    id: "path24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "sarcoidosis",
    points: "64.61 33.14 68.01 30.79 68.01 25.39",
    id: "polyline25"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3",
    clipPath: "url(#clippath-sarcoidosis-7)",
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "sarcoidosis",
    d: "m 70.31,28.23 c 1.1,-1.13 2.46,-0.41 3.76,1.17 1.7,2.06 2.06,3.86 2.41,5.76 0.41,2.22 0.81,6.15 -1.13,6.84 -1,0.36 -7.79,2.7 -5.6,-8.71 0.21,-1.09 -0.5,-3.96 0.56,-5.05 z",
    id: "path25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "sarcoidosis",
    points: "71.54 33.14 68.14 30.79 68.14 25.39",
    id: "polyline26"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "sarcoidosis",
    cx: 62.91,
    cy: 38.990002,
    r: 1.25,
    id: "circle27"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "sarcoidosis",
    cx: 61.66,
    cy: 35.720001,
    r: 0.059999999,
    id: "circle28"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "sarcoidosis",
    cx: 64.309998,
    cy: 35.720001,
    r: 0.30000001,
    id: "circle29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSarcoidosis);
export default __webpack_public_path__ + "static/media/Sarcoidosis.f859504ab9db08e97488fa30a0201eec.svg";
export { ForwardRef as ReactComponent };